export default __webpack_public_path__ + "static/media/56t.f9145c99.jpg";